import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { requerido, numero } from './Validaciones'
import { consultaUsuario } from './ConsultaUser'

export const ConsultSemestres = (respuesta) => {
    Post(`${Url}consultSemestres`, "", (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                {
                    value: data[i].id,
                    label: (`${data[i].semestre_name} - [${data[i].carrera_name}]`),
                    num: data[i].semestre_num,
                    carrera: data[i].carrera_id
                }
            )
        }
        respuesta(contenido)
    });
}

export const consultCarreras = (respuesta) => {
    Post(`${Url}consultCarreras`, "", (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let contenido= [];

        for (let i in data) {
            contenido.push(
                { value: data[i].id, label: data[i].carrera_name }
            )
        }
        respuesta(contenido)
    });
}

export const ConsultaMaterias = (idSemestre, numSemestre, carrera, respuesta) => {
    let Content = {
        id: idSemestre,
        semestre: numSemestre,
        carrera: carrera
    }

    Post(`${Url}consultMaterias`, Content, (resp) => {
        let data1 = JSON.parse(resp);
        let data = data1[0];
        let matPrelacion = data1[1];
        let modalidades = data1[2];
        let tiposMat = data1[3];

        let contenido= [];
        let prelacion = [{
            value: "",
            label: "- No Aplica -",
        }];
        let contentMod = [];
        let contentTipo = [];

        for (let i in data) {
            contenido.push({
                id: data[i].id,
                codigo: data[i].codigo,
                nombre: data[i].materia_name,
            })
        }

        for (let i in matPrelacion) {
            prelacion.push({
                value: matPrelacion[i].codigo,
                label: `[${matPrelacion[i].codigo}] - ${matPrelacion[i].materia_name}`,
                id: matPrelacion[i].id
            })
        }

        for (let i in modalidades) {
            contentMod.push({
                value: modalidades[i].id,
                label: modalidades[i].modalidad_name,
            })
        }

        for (let i in tiposMat) {
            contentTipo.push({
                value: tiposMat[i].id,
                label: tiposMat[i].tipomat_name,
            })
        }

        let states = {
            materiasDisp: contenido,
            prelaciones: prelacion,
            modalidades: contentMod,
            TiposMat: contentTipo,
            preloader:{
                icon: "",
                text: ""
            },
            openDelMat: false,
        }

        respuesta(states)
    });
}

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorSemestre.value, "", "", "", "Debes seleccionar primero un Semestre de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.codigo.text, "", "", "", "El Código de la Materia Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El Nombre de la Materia Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.horas.text, "", "", "", "Selecciona la cantidad de Horas para esta materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* numero(errores, campos.horas.text, "", "", "El campo Horas debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    }); */

    requerido(errores, campos.uc.text, "", "", "", "Selecciona la cantidad de Unidades de Crédito para esta materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.uc.text, "", "", "El campo U.C. debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorModalidad.value, "", "", "", "Debes seleccionar la Modalidad para esta materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorTipoMat.value, "", "", "", "Debes seleccionar el Tipo de materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    

    if (errores === 0){
        consultaUsuario ((usu) => {
            
            Post(`${Url}addMateria`, [campos, usu], (resp) => {
                
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha guardado correctamente la asignatura"
                }];

                
                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const verMateria = (id, respuesta) => {
    let contenido = { id: id }
    Post(`${Url}verMateria`, contenido, (resp) => {
        let data = JSON.parse(resp)
        console.log(data)
        let prelacion1 = " - NO DISPONIBLE - ";
        let idPrel1 = "";

        if (data[1] !== null){
            prelacion1 = data[1].materia_name;
            idPrel1 = data[1].id
        }

        let prelacion2 = " - NO DISPONIBLE - ";
        let idPrel2 = "";

        if (data[2] !== null){
            prelacion2 = data[2].materia_name;
            idPrel2 = data[2].id
        }

        let state = {
            cantErrores: "",
            codigo:  { text:data[0].codigo, status: "" },
            nombre:  { text:data[0].materia_name, status: "" },
            horas:  { text:data[0].horas, status: "" },
            uc:  { text:data[0].u_c, status: "" },
            valorPrelacion1: { value: data[0].prelacion_1, label: prelacion1, id: idPrel1},
            valorPrelacion2: { value: data[0].prelacion_2, label: prelacion2, id: idPrel2},
            valorModalidad: { value: data[0].modalidad_id, label: data[0].modalidad_name },
            valorTipoMat: { value: data[0].tipo_mat, label: data[0].tipomat_name },
            chkIntensivo:  data[0].intensivo,
            openDelMat: false,
            preloaderAsig:{ icon: "", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
        }

        respuesta (state)  
    });
}

export const Delete = (id, respuesta) => (e) => {
    consultaUsuario ((usu) => {
        let contenido = { id: id }
        Post(`${Url}delMateria`, [contenido, usu], (resp) => {
            respuesta (resp)
        });
    });
}

export const Editar = (idMate, campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.valorSemestre.value, "", "", "", "Debes seleccionar primero un Semestre de tu izquierda", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.codigo.text, "", "", "", "El campo Código de la Materia Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nombre.text, "", "", "", "El campo Nombre de la Materia Es Obligatorio", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.horas.text, "", "", "", "Selecciona la cantidad de Horas para esta materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    /* numero(errores, campos.horas.text, "", "", "El campo Horas debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    }); */

    requerido(errores, campos.uc.text, "", "", "", "Selecciona la cantidad de Unidades de Crédito para esta materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.uc.text, "", "", "El campo U.C. debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorModalidad.value, "", "", "", "Debes seleccionar la Modalidad para esta materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorTipoMat.value, "", "", "", "Debes seleccionar el Tipo de materia", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    

    if (errores === 0){
        consultaUsuario ((usu) => {
            Post(`${Url}editMateria`, [campos, usu, idMate], (resp) => {
                console.log(resp)
                mensaje = [{
                    status: "info",
                    mensaje: "Se ha actualizado correctamente la asignatura"
                }];

                respuesta([states, mensaje, errores, nameErr])
            });
        })
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}


// WEBPACK FOOTER //
// ./src/funciones/MateriasFunction.jsx